import ValueX from '../types/ValueX';

export default class EffectiveX extends ValueX {
    static __className = 'EffectiveX';

    constructor(constructJson) {
        super(constructJson, 'effective', 'EffectiveX');
    }
}
